/**
 * 페이지 나누기 기능 슬라이스 — 블록 직렬화 + 슬래시 항목을 한 폴더에서 소유.
 * (CSS: ./page-break.css, style.css 에서 @import)
 */
import { pageBreakBlockToElement, pageBreakElementToBlock } from "./page-break.js";

export default {
  name: "pageBreak",
  blocks: {
    pageBreak: { toElement: pageBreakBlockToElement, fromElement: pageBreakElementToBlock },
  },
  slash: (ctx) => {
    const SM = (ctx.locale && ctx.locale.slashMenu) || {};
    return [
      {
        type: "pageBreak",
        label: SM.pageBreak || "페이지 나누기",
        kw: "page break separator divider 페이지 나누기 구분 hr",
        group: SM.groupBasic || "기본 블록",
        ico: "—",
        sub: "페이지 구분선",
        action: () => ctx.insertBlocks([{ type: "pageBreak", props: {}, content: [], children: [] }]),
      },
    ];
  },
};
